import {
  PluginEquifaxPpsrGrantorSearchRequest,
  PluginEquifaxPpsrGrantorSearchRequestResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxPpsrGrantorSearchRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxPpsrGrantorSearchRequest,
): Promise<
  | NonPaginatedResponse<PluginEquifaxPpsrGrantorSearchRequestResponse>
  | undefined
> =>
  constructPost<
    NonPaginatedResponse<PluginEquifaxPpsrGrantorSearchRequestResponse>
  >(
    `${PLUGIN_BASE_PATH}/equifax-ppsr-grantor-search-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
